import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { ScatterPlot } from "@/tools/scatter-plot/components/ScatterPlot";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.bubble_tool_name()}
        toolPath="/bubble-chart"
      />
      <SciHeader title={m.bubble_h1()} intro={m.bubble_intro()} />

      <ScatterPlot bubble />

      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.bubble_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.bubble_ex1(), m.bubble_ex2(), m.bubble_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.bubble_faq_q1(), a: m.bubble_faq_a1() },
          { q: m.bubble_faq_q2(), a: m.bubble_faq_a2() },
          { q: m.bubble_faq_q3(), a: m.bubble_faq_a3() },
          { q: m.bubble_faq_q4(), a: m.bubble_faq_a4() },
        ]}
      />

      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
